import Route from "@ember/routing/route";

export default class DashboardSettingsRoute extends Route {
  buildRouteInfoMetadata() {
    return { jumpable: true };
  }
}
